import { render, staticRenderFns } from "./ShuttleLiveInfo.vue?vue&type=template&id=3357335a&scoped=true&"
import script from "./ShuttleLiveInfo.vue?vue&type=script&lang=js&"
export * from "./ShuttleLiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleLiveInfo.vue?vue&type=style&index=0&id=3357335a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3357335a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3357335a')) {
      api.createRecord('3357335a', component.options)
    } else {
      api.reload('3357335a', component.options)
    }
    module.hot.accept("./ShuttleLiveInfo.vue?vue&type=template&id=3357335a&scoped=true&", function () {
      api.rerender('3357335a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Shuttle/ShuttleLiveInfo.vue"
export default component.exports